<i18n>
{
  "fr": {
    "cancel": "Retour",
    "save": "Enregistrer",
    "loading": "Chargement...",
    "modifyInformations": "Modifier la propriété",
    "send":"Envoyer",
    "download":"Télécharger",
    "upload":"Téléverser (vers la GED)"
  }
}
</i18n>

<template>
  <b-row :class="{noActive : isProcessing }">
    <b-col :class="{ 'no-data': isProcessing }">
      <b-card
        body-class="pd-15 mg-b-15"
        header-class="bg-white bd-b-1 pd-15"
        class="card-hover card-suze mg-b-15"
      >
        <template v-slot:header>
          <h4>Gestion de courrier / Suivi de facturation</h4>
          <div class="d-flex">
            <a class="btn s-btn-b btn-gray pull-right mg-r-15" @click="onCancel">{{ $t('cancel') }}</a>
            <router-link
              class="btn btn-cta s-btn pull-right"
              :to="{ name: 'property_edit', params: { propertyId: property.id } }"
            >{{ $t('modifyInformations') }}</router-link>
          </div>
        </template>
        <div class="row" v-if="loaded">
          <div v-if="property" class="col-sm-6">
            <h4>Informations sur la propriété :</h4>

            <b>N° dossier</b> :
            <span v-if="property.folderNumber">{{ property.folderNumber }}</span>
            <span v-else>N/A</span>
            <br />
            <b>Type de propriété</b> :
            <span
              v-if="property.propertyType && property.propertyType.internalLabel"
            >{{ property.propertyType.internalLabel }}</span>
            <span v-else>N/A</span>
            <br />
            <b>Date de création</b> :
            <span
              v-if="property.creationDate"
            >{{ formatDate(property.creationDate.split('T')[0]) }}</span>
            <span v-else>N/A</span>
            <br />
            <b>N° Police</b> :
            <span
              v-if="property.address && property.address.numberStreet"
            >{{ property.address.numberStreet }}</span>
            <span v-else>N/A</span>
            <br />
            <b>Rue</b> :
            <span v-if="property.address && property.address.street">{{ property.address.street }}</span>
            <span v-else>N/A</span>
            <br />
            <b>Commune</b> :
            <span v-if="property.address && property.address.town">{{ property.address.town }}</span>
            <span v-else>N/A</span>
            <br />
            <b>Code postal</b> :
            <span
              v-if="property.address && property.address.zipCode"
            >{{ property.address.zipCode }}</span>
            <span v-else>N/A</span>
            <br />
          </div>

          <div v-if="control" class="col-sm-6">
            <h4>Résumé du contrôle :</h4>

            <b>Type</b> :
            <span
              v-if="this.control && this.control.type"
            >{{ this.control.type ? this.control.type : 'N/A' }}</span>
            <span v-else>N/A</span>
            <br />
            <b>Date</b> :
            <span v-if="control.data && control.data.dateOfVisit">{{ control.data.dateOfVisit }}</span>
            <span v-else>N/A</span>
            <br />
            <b>Etat</b> :
            <span
              v-if="control.data && control.data.controlStatus"
            >{{ control.data.controlStatus }}</span>
            <span v-else>N/A</span>
            <br />
            <b>Créateur</b> :
            <span
              v-if="control.data && control.data.user"
            >{{ (control.data.user.firstName || '') + ' ' + (control.data.user.lastName || '') }}</span>
            <span v-else>N/A</span>
          </div>
        </div>
      </b-card>

      <b-card
        body-class="pd-0 mg-b-15"
        header-class="bd-b-1 card-header-bg "
        class="card-hover card-suze mg-b-15"
      >
        <template v-slot:header>
          <h1>Gestion de courrier</h1>
        </template>
        <div class="card-header bg-white bd-b-1 pd-15">
          <h4>Génération de courrier :</h4>
        </div>
        <div class="pd-15">
          <form v-on:submit.prevent="onMailFormSubmit" method="POST">
            <div class="row">
              <div class="col-sm-6">
                <div class="row">
                  <div class="col-sm-12">
                    <b>
                      Contact
                      <span class="red">*</span>:
                    </b>
                    <select v-model="contactSelected" class="form-control form-control-sm" >
                      <option v-bind:value="null">Sélectionner le contact</option>
                      <option
                        v-for="contact in property.contacts"
                        v-bind:key="contact.id"
                        v-bind:value="contact.id"
                      >
                        {{ contact.name }} {{ contact.firstName }}
                        <span
                          v-if="contact.typeContact.length > 0"
                        >
                          (
                          <div v-for="(t,index) in contact.typeContact" :key="index+10">
                            {{t}}
                            <div v-if="(index+1)<contact.typeContact.length">,&nbsp;</div>
                          </div>)
                        </span>
                      </option>
                    </select>
                    <br />
                  </div>
                  <div v-if="property" class="col-sm-6">
                    <b class="mg-r-5">Type de contact :</b>
                    <span
                      v-if="contact && contact.typeContact.length > 0"
                    >{{ contact.typeContact[0] }}</span>
                    <span v-else>N/A</span>
                    <br />
                    <b class="mg-r-5">Civilité :</b>
                    <span v-if="contact">{{ contact.title }}</span>
                    <span v-else>N/A</span>
                    <br />
                    <b class="mg-r-5">Nom :</b>
                    <span v-if="contact">{{ contact.name }}</span>
                    <span v-else>N/A</span>
                    <br />
                    <b class="mg-r-5">Prénom :</b>
                    <span v-if="contact">{{ contact.firstName }}</span>
                    <span v-else>N/A</span>
                    <br />
                    <b class="mg-r-5">Adresse :</b>
                    <span v-if="contact">
                      {{ contact.numberStreet }} {{ contact.street }}
                      <br />
                      {{ contact.zipCode }} {{ contact.town }}
                    </span>
                    <span v-else>N/A</span>
                    <br />
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="row">
                  <div class="col-sm-12">
                    <b>
                      Type de courrier
                      <span class="red">*</span> :
                    </b>
                    <br />
                    <br />
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <div
                        v-for="contract_template in this.getContractTemplates()"
                        v-bind:key="contract_template.key"
                      >
                        <input
                          v-bind:id="contract_template.name"
                          v-bind:value="contract_template.name"
                          type="radio"
                          v-model="contractTemplateSelected"
                          class="form-control"
                        />
                        <label v-bind:for="contract_template.name">{{ contract_template.name }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <b>Date de génération</b>
                        <span class="red">*</span> :
                      </div>
                      <div class="col-md-6">
                        <div class="input-group mb-3">
                          <input
                            v-model="mail.generationDate"
                            type="date"
                            class="form-control"
                            required
                            v-on:blur="compar()"
                          />
                        </div>
                        <div
                          v-if="this.control != null && this.control.currentStatus != null && this.diff"
                          style="color:red"
                        >Date non Valide</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <button
                  type="submit"
                  v-bind:disabled="this.diff === true || this.contactSelected === null||  this.contractTemplateSelected === null ||  this.mail.generationDate === null"
                  class="btn btn-cta s-btn"
                >
                  <template v-if="submitTrackingContractMail">
                    <strong>{{$t('loading')}}</strong>
                    <b-spinner class="ml-auto"></b-spinner>
                  </template>
                  <span v-else>Générer le courrier</span>
                </button>
              </div>
              <div
                class="col-sm-6"
                v-if="this.control != null && this.control.currentStatus != null && this.validationStatus != null"
              >
                <div>{{this.validationStatus.status.label}} le : {{formatDateYMDHM(this.validationStatus.createdAt)}}</div>
              </div>
            </div>
          </form>
        </div>
        <div class="card-header bg-white b-t-1-s b-b-1-s pd-15">
          <h4>Historique de génération de courrier :</h4>
        </div>
        <div class="pd-0">
          <div class="responsive histo">
            <table class="table table-striped admin-list">
              <thead>
                <tr class="thead-color">
                  <th class="pd-lr-10">Nom du générateur</th>
                  <th>Date</th>
                  <th class="pd-lr-10">Nom du courrier</th>
                  <th>Nom du destinataire</th>
                  <th class="pd-lr-10">Adresse du contact</th>
                  <th class="ged_up">Date d'envoi en GED</th>
                  <th class="pd-lr-10">Envoyé par</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="mail in this.getTrackingContractMails()" v-bind:key="mail.key">
                  <td>{{ mail.owner.firstName }} {{ mail.owner.lastName }}</td>
                  <td>{{ formatDate(mail.generationDate) }}</td>
                  <td>
                    <span class="templateName_css">{{ mail.filename }}</span>
                  </td>
                  <td>{{ mail.contact.title == other ? "": mail.contact.title }} {{ mail.contact.name }} {{ mail.contact.firstName }}</td>
                  <td
                    style="white-space:nowrap"
                    class="w-26"
                  >{{ mail.contact.numberStreet }} {{ mail.contact.street }} {{ mail.contact.town }} {{ mail.contact.zipCode }}</td>
                  <td>{{gedGetSenderDate(mail.uploadsHistory)}}</td>
                  <td>{{gedGetSenderName(mail.uploadsHistory)}}</td>
                  <td class="tx-center">
                    <a
                      v-bind:href="'/fr/tracking/contract/' +  mail.contractId + '/mails/' + mail.id + '/download'"
                      target="_blank"
                    >
                      <v-icon name="file-download" :title="$t('download')"/>
                    </a>

                    <a
                      href="#"
                      data-toggle="modal"
                      data-target="#mailUploadModal"
                      v-on:click="setMailFileId(mail.id)"
                    >
                      <v-icon name="file-upload" :title=" $t('upload')"/>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <div
              class="modal"
              id="mailUploadModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="mailUploadModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Importer</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <input
                      type="file"
                      class
                      id="mailFile"
                      ref="mailFile"
                      accept=".pdf"
                      v-on:change="handleMailFileUpload()"
                    />
                    <br />
                    <button
                      v-bind:disabled="! this.mailFile"
                      class="btn btn-cta s-btn pull-right"
                      v-on:click="submitMailFile()"
                    >
                      <template v-if="mailFileUplodStatus && mailFileUplodStatus === 'inProgress'">
                        <strong>{{$t('loading')}}</strong>
                        <b-spinner class="ml-auto"></b-spinner>
                      </template>
                      <span>{{$t('send')}}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
      <b-card
        body-class="pd-0 mg-b-15"
        header-class="bd-b-1  card-header-bg"
        class="card-hover card-suze mg-b-15"
      >
        <template v-slot:header>
          <h1>Suivi de facturation</h1>
        </template>

        <div class="card-header bg-white bd-b-1 pd-15">
          <h4>Enregistrement de facturation :</h4>
        </div>
        <div class="pd-15">
          <form v-on:submit.prevent="onInvoiceFormSubmit" method="POST">
            <b-row class="my-1">
              <b-col sm="3">
                <label>
                  Date de facturation
                  <code class="red">*</code>
                  :
                </label>
              </b-col>
              <b-col sm="9">
                <input v-model="invoice.invoiceDate" type="date" class="form-control" required />
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="3">
                <label>
                  Prix de la prestation
                  <code class="red">*</code>
                  :
                </label>
              </b-col>
              <b-col sm="9">
                <input
                  v-model="invoice.price"
                  type="number"
                  step="any"
                  class="form-control"
                  size="5"
                  required
                />
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="3">
                <label>Commentaire</label>
              </b-col>
              <b-col sm="9">
                <textarea v-model="invoice.comment" class="form-control" rows="5"></textarea>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="9"></b-col>
              <b-col sm="3">
                <button
                  type="submit"
                  v-bind:disabled="this.invoice.price === null || this.invoice.price === ''"
                  class="btn btn-cta s-btn pull-right"
                >
                  <template v-if="submitTrackingContractInvoice">
                    <strong>{{$t('loading')}}</strong>
                    <b-spinner class="ml-auto"></b-spinner>
                  </template>

                  <span>{{ $t('save') }}</span>
                </button>
              </b-col>
            </b-row>
          </form>
        </div>

        <div class="card-header bg-white b-t-1-s b-b-1-s pd-15">
          <h4>Historique de facturation :</h4>
        </div>
        <div class="pd-0">
          <table class="table table-striped admin-list" aria-describedby="InvoiceHitoriy">
            <thead>
              <tr class="thead-color">
                <th scope="col">Nom du générateur</th>
                <th scope="col">Date</th>
                <th scope="col">Prix</th>
                <th scope="col">Commentaire</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="invoice in this.getTrackingInvoices()" v-bind:key="invoice.key">
                <td>{{ invoice.owner_first_name }} {{ invoice.owner_last_name }}</td>
                <td>{{ formatDate(invoice.invoiceDate.date) }}</td>
                <td>{{ invoice.price }} €</td>
                <td>{{ invoice.comment }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
    <ajax-intercept @start="ajaxStart" @finish="ajaxFinish"></ajax-intercept>
  </b-row>
</template>

<script>
import VueJwtDecode from 'vue-jwt-decode';
import { mapState } from 'vuex';
import moment from 'moment';
import { formatDate, formatDateTime, addMn } from '../../utils/formatDate';
import ajaxIntercept from 'vue-ajax-intercept';
import axios from 'axios';
import { VALUE_OTHER } from '../../constants/params';

export default {
  name: 'MailManagementIndex',
  components: {
    ajaxIntercept,
  },
  data() {
    return {
      other: VALUE_OTHER,
      validationStatus: null,
      loaded: false,
      diff: false,
      jwtDecoded: null,
      contactSelected: null,
      contractId: null,
      contractTemplates: [],
      contractTemplateSelected: null,
      mail: {},
      invoice: {
        price: null,
        comment: null,
      },
      owner: null,
      loading: true,
      submitTrackingContractMail: false,
      submitTrackingContractInvoice: false,
      isProcessing: false,
      ajaxInterceptorCounter: 0,
      mailFile: '',
      mailFileId: '',
      mailFileUplodStatus: null,

    };
  },
  computed: {
    ...mapState({
      workflows: state => state.workflow.workflows,
      property: state => state.refProperties.property,
      control: state => state.refControls.control,
    }),
    contact() {
      if(this.property.contacts)
      {
        let index = this.property.contacts.findIndex(contact => contact.id === this.contactSelected);
        let contact = null;

        if (index > -1) {
          contact = this.property.contacts[index];
        }

        return contact;
      }
      return null;
    },
  },
  methods: {
    gedGetSenderName(obj) {
      // slice(-1) Extract only the last element, the return format is an array with one element
      if (obj && obj.slice(-1)[0]) {
        return obj.slice(-1)[0].owner.firstName + ' ' + obj.slice(-1)[0].owner.lastName;
      }
    },
    gedGetSenderDate(obj) {
      // slice(-1) Extract only the last element, the return format is an array with one element
      if (obj && obj.slice(-1)[0] && obj.slice(-1)[0].createdAt) {
        return this.formatDateDateTime(obj.slice(-1)[0].createdAt);
      }
    },
    formatDateDateTime(date) {
      var arr = date.split('T');
      var arrDate = arr[0].split('-');
      var dateH = arr[1].split(':');
      return arrDate[2] + '/' + arrDate[1] + '/' + arrDate[0] + ' ' + dateH[0] + ':' + dateH[1];
    },
    getValidationStatus() {
      if (this.workflows) {
        this.workflows.forEach((component) => {
          if (component.status.id === 'validated') {
            this.validationStatus = component;
          }
        });
      }
    },
    fetchWorkflows() {
      this.$store.dispatch('fetchWorkflows').then(() => this.getValidationStatus());
    },
    compar: function() {
      this.diff = moment(this.formatDateYMDT(this.validationStatus.createdAt)).isAfter(this.mail.generationDate);
    },
    comparFirst: function() {
      return moment(this.formatDateYMDT(this.control.currentStatus.createdAt)).isAfter(this.mail.generationDate);
    },
    formatDateYMD: function(value) {
      if (value) {
        return moment(String(value)).format('YYYYMMDD');
      }
    },
    formatDateYMDT: function(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD');
      }
    },
    formatDateYMDHM: function(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm');
      }
    },
    get: function(obj, key) {
      return key.split('.').reduce(function(o, x) {
        return typeof o == 'undefined' || o === null ? '' : o[x];
      }, obj);
    },

    onCancel() {
      this.$router.push({ name: `property_detail`, params: { propertyId: this.property.id } });
    },
    getContractTemplates() {
      return this.$store.getters.getTrackingContractTemplates;
    },
    getTrackingContractMails() {
      return this.$store.getters.getTrackingContractMails;
    },
    getTrackingInvoices() {
      return this.$store.getters.getTrackingContractInvoices;
    },
    setIdProperty() {
      this.$store.dispatch('setIdProperty', { id: this.$route.params.propertyId });
      this.$store.dispatch('fetchProperty', { id: this.$route.params.propertyId });
    },
    add_minutes: function(dt, minutes) {
      return new Date(dt.getTime() + minutes * 60000);
    },
    onMailFormSubmit() {
      if (this.formatDateYMD(this.validationStatus.createdAt) === this.formatDateYMD(this.mail.generationDate)) {
        let dt = new Date(this.validationStatus.createdAt);
        let val = this.add_minutes(dt, 5);
        this.mail.generationDate = moment(String(val)).format('YYYY-MM-DD HH:mm');
      } else {
        this.mail.generationDate = moment(String(this.mail.generationDate)).format('YYYY-MM-DD HH:mm');
      }
      this.mail.templateName = this.contractTemplateSelected;
      this.mail.contact = { id: this.contact.id };
      this.mail.generationDate = this.mail.generationDate;
      delete this.owner.contractsIds;
      this.$store
        .commit('submitTrackingContractMail', this.mail);
    },

    dateTime(date) {
      return formatDateTime(date);
    },
    addMunite(date, mn) {
      return addMn(date, mn);
    },
    formatDate(value) {
      return formatDate(value);
    },
    onInvoiceFormSubmit() {
      delete this.owner.contractsIds;

      this.$store.commit('submitTrackingContractInvoices', this.invoice);
    },
    ajaxStart() {
      this.ajaxInterceptorCounter++;
      this.isProcessing = true;
    },
    ajaxFinish() {
      this.ajaxInterceptorCounter--;
      if (this.ajaxInterceptorCounter <= 0) {
        this.isProcessing = false;
      }
    },
    handleMailFileUpload() {
      this.mailFile = this.$refs.mailFile.files[0];
    },
    setMailFileId(mailFileId) {
      this.mailFileId = mailFileId;
    },
    submitMailFile() {
      this.mailFileUplodStatus = 'inProgress';
      let formData = new FormData();
      let data = {
        owner: {
          firstName: this.owner.firstName,
          lastName: this.owner.lastName,
        },
      };
      formData.append('file', this.mailFile);
      formData.append('data', JSON.stringify(data));
      axios
        .post(`/fr/tracking/contract/${this.contractId}/mails/${this.mailFileId}/upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(function() {
          console.log('SUCCESS!!');
          alert('Le fichier a été envoyé en GED avec succès');
        })
        .catch(function() {
          console.log('FAILURE!!');
        })
        .then(() => {
          this.mailFile = '';
          this.mailFileUplodStatus = null;
          this.$refs.mailFile.value = '';
          $('#mailUploadModal').modal('hide');
          this.$store.commit('setTrackingContractMails', this.mail);
        });
    },
  },
  mounted() {
    this.jwtDecoded = VueJwtDecode.decode(this.$store.state.app.parameters.jwt);

    this.contractId = this.jwtDecoded.data.user.contractsIds[0];
    this.owner = this.jwtDecoded.data.user;

    (this.mail.contractId = this.contractId),
      (this.mail.propertyId = this.$route.params.propertyId),
      (this.mail.controlId = this.$route.params.controlId),
      (this.mail.owner = this.owner);

    (this.invoice.contractId = this.contractId),
      (this.invoice.propertyId = this.$route.params.propertyId),
      (this.invoice.controlId = this.$route.params.controlId),
      (this.invoice.owner = this.owner);

    this.$store.commit('setTrackingContractMails', this.mail);
    this.$store.commit('setTrackingContractInvoices', this.invoice);
    this.fetchWorkflows();
    this.$store
      .dispatch('fetchControl', {
        propertyId: this.$route.params.propertyId,
        controlId: this.$route.params.controlId,
      })
      .then(() => {
        this.$store.commit('setTrackingContractTemplates', {
          contractId: this.contractId,
          query: {
            metadataFilters: [
              'property_eap=' + this.property.complianceSurveyOnly,
              'request_type=' + this.control.type,
            ],
          },
        });
        this.loaded = true;
      });

    this.$store.subscribe(mutation => {
      switch (mutation.type) {
        case 'setControl':
          break;
        case 'submitTrackingContractMail':
          this.submitTrackingContractMail = true;
          break;
        case 'setTrackingContractMails':
          this.submitTrackingContractMail = false;
          this.contractTemplateSelected = null;
          this.contactSelected = null;
          this.mail.templateName = null;
          delete this.mail.contact;
          this.mail.generationDate = new Date().toISOString().split('T')[0];
          break;
        case 'submitTrackingContractInvoices':
          this.submitTrackingContractInvoice = true;
          break;
        case 'setTrackingContractInvoices':
          this.submitTrackingContractInvoice = false;
          this.invoice.price = null;
          this.invoice.comment = null;
          this.invoice.invoiceDate = new Date().toISOString().split('T')[0];
          break;
      }
    });
  },
  created: function() {
    if (!this.mail.generationDate) {
      this.mail.generationDate = new Date().toISOString().split('T')[0];
    }

    if (!this.invoice.invoiceDate) {
      this.invoice.invoiceDate = new Date().toISOString().split('T')[0];
    }
    this.setIdProperty();
  },
};
</script>

<style scoped>
* {
  text-align: left;
}

h1 {
  margin-top: 40px;
  font-size: 20px;
}

h4 {
  margin-bottom: 0px;
  color: #404888;
}

h3 {
  padding-top: 8px;
  color: #ffffff;
}

.row {
  margin-bottom: 20px;
}

.return {
  float: right;
  margin-top: 20px;
}

.section-header {
  background-color: #404888;
  font-family: 'DIN Pro Condensed Medium', sans-serif !important;
  font-size: 14px;
  color: #ffffff;
  height: 36px;
  line-height: 36px;
  padding-top: 3px;
}

.input-group-text > i {
  font-size: 14px;
}

.thead-color {
  background-color: #404888;
  color: #ffffff;
}
.pd-lr-10 {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.histo .table tbody > tr td,
.histo .table thead > tr th {
  padding-left: 5px !important;
  padding-right: 5px !important;
  text-align: center !important;
}
.ged_up {
  text-transform: uppercase !important;
}
.ged_up {
  text-transform: initial !important;
}
.templateName_css {
  max-width: 150px !important;
  display: block;
}
</style>
